import { inject } from '@angular/core';
import { Router, type CanActivateFn } from '@angular/router';
import { AuthStore } from '@features/auth/auth.store';
import { AppPaths } from '@core/routes/app-paths';
import { hasPreferredCompaniesAccess } from '@core/utils/role.utils';

/**
 * Restricts Preferred Companies route to contractor companies only (not ITO/MTO trucking).
 */
export const preferredCompaniesAccessGuard: CanActivateFn = () => {
  const authStore = inject(AuthStore);
  const router = inject(Router);

  const user = authStore.user();
  const hasAccess = hasPreferredCompaniesAccess({
    primaryRole: user?.primaryRole,
    roles: user?.roles,
  });

  if (hasAccess) {
    return true;
  }

  return router.createUrlTree([AppPaths.PROFILE]);
};
